module.exports = __webpack_public_path__ + "static/payouts-foreground-e765bb932de9ada4f96351f8ad964c9d.webp";